import apiClient from "../../services/ApiClientService";
import { dataLoading } from "../decorators/LoadingAction.decorator";
import { EmailDetail } from "../models/EmailDetail";
import { EmailTemplate } from "../models/EmailTemplate";
import { EmailUpdateModel } from "../models/EmailUpdateModel";
import { Utilities } from "../utils/utilities";

export class ReviewSendEmailsApi {
  @dataLoading([])
  static async generateEmails(eventId: string, eventCalculationId: string) {
    const response = await apiClient.get(`/api/email/GenerateEmails?surchargeEventId=${eventId}&SurchargeEventCalculationId=${eventCalculationId}`);
    if (response.status === 200) {
      return response.data as EmailDetail[];
    } else {
      return [];
    }
  }

  @dataLoading([])
  static async getEmails(surchargeEventCalculationId: string) {
    if (Utilities.isNullOrEmptyString(surchargeEventCalculationId)) {
      return [];
    }

    var result = await apiClient.get(`/api/email/getEmails?surchargeEventCalculationId=${surchargeEventCalculationId}`);
    if (result.status === 200) {
      return result.data as EmailDetail[];
    } else {
      return [];
    }
  }

  @dataLoading(undefined)
  static async regenerateEmails(eventId: string, eventCalculationId: string, shipto: string) {
    const response = await apiClient.post(`/api/email/Regenerate?eventId=${eventId}&eventCalculationId=${eventCalculationId}&shipto=${shipto}`);
    if (response.status === 200) {
      return response.data as EmailUpdateModel;
    } else {
      return undefined;
    }
  }

  @dataLoading(false)
  static async markAsSentOrUnsend(model: EmailDetail, send: boolean) {
    // only SurchargeEventCalculationId and ShipTo is used by backend
    const response = await apiClient.post(send ? "/api/email/MarkAsSent" : "/api/email/MarkAsUnSent", {
      Html: model.html,
      Recipients: model.recipients,
      Subject: model.subject,
      SurchargeEventCalculationId: model.surchargeEventCalculationId,
      ShipTo: model.shipTo,
      User: model.createdBy,
      Name: model.name,
      FromTemplate: model.fromTemplate,
    });

    return response.status === 200;
  }

  @dataLoading(false)
  static async saveTemplate(model: any) {
    const response = await apiClient.post("/api/email/SaveTemplate", model);
    return response.status === 200;
  }

  @dataLoading([])
  static async getAllTemplates() {
    var result = await apiClient.get("/api/email/GetAllTemplates");
    if (result.status === 200) {
      return result.data as EmailTemplate[];
    } else {
      return [];
    }
  }
}
